var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBellHalf20(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon/Bell-Half",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.544 17.27l-.035.042a2 2 0 01-3.504-1.163L8 16l3.1.001c.091.448.242.873.444 1.269zM10 2a1.5 1.5 0 011.5 1.5V5h-3V3.5A1.5 1.5 0 0110 2z",
    id: "Combined-Shape",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 4a5 5 0 015 5v1.1a5.002 5.002 0 00-4 4.9H4a1 1 0 01-1-1v-.295a1 1 0 01.664-.942l.336-.12c.6-.214 1-.782 1-1.419V9a5 5 0 015-5z",
    id: "bell-body",
    fillOpacity: 0.35,
    fill: "currentColor",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 4a5 5 0 015 5v1.1c-.348.07-.682.177-1 .316V9a4 4 0 00-7.995-.2L6 9v2.224c0 .997-.59 1.893-1.491 2.292l-.173.069-.336.12V14h7.1c-.066.323-.1.657-.1 1H4a1 1 0 01-1-1v-.295a1 1 0 01.664-.942l.336-.12c.6-.214 1-.782 1-1.419V9a5 5 0 015-5z",
    id: "Combined-Shape",
    fill: "currentColor",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "currentColor",
    cx: 16,
    cy: 15,
    r: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 11v8a4 4 0 110-8z",
    id: "Combined-Shape",
    fill: "currentColor"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBellHalf20);
export default __webpack_public_path__ + "static/media/bell-half-20.14acec3e.svg";
export { ForwardRef as ReactComponent };